import React from 'react';
import Table from './Table';
import Pagination from './Pagination';

function DataTable(props) {
  const { hidePagination = false } = props;

  return (
    <>
      <Table {...props} />
      {!hidePagination && <Pagination {...props} />}
    </>
  );
}

export default DataTable;
